import React from 'react';
import { Callout } from './Callout';
import { Divider } from '../Divider';
import UniversalNavLink from '../../UniversalNavLink';
import { isLinkSelected } from './utils';
const InAppLinks = ({ isCollapsed, links, callout, selectedHref, }) => (React.createElement(React.Fragment, null,
    links.map((itemGroup, index) => (React.createElement(React.Fragment, { key: index },
        React.createElement("li", { "aria-hidden": "true", key: index },
            React.createElement(Divider, null)), itemGroup === null || itemGroup === void 0 ? void 0 :
        itemGroup.map((item) => {
            const isSelected = isLinkSelected(item.href || '', selectedHref);
            const icon = isSelected ? item.iconFilled : item.icon;
            return (React.createElement("li", { key: item.text },
                React.createElement(UniversalNavLink, { href: item.href, icon: icon, isCollapsed: isCollapsed, isSelected: isSelected, isSidebar: true, isV3Link: true, text: item.text, tag: item.tag })));
        })))),
    callout && !isCollapsed && (React.createElement("li", { key: "callout" },
        React.createElement(Callout, Object.assign({}, callout))))));
export default InAppLinks;
//# sourceMappingURL=InAppLinks.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
